import { jsx as _jsx } from "react/jsx-runtime";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import EditIcon from "@mui/icons-material/Edit";
import { Button, IconButton } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
// Standard card action affordances (LS-389): "See All" is a labelled link to a
// full read-only view; "Manage" is a compact, uniform edit icon.
export var SeeAllButton = function (_a) {
    var to = _a.to;
    return (_jsx(Button, { component: RouterLink, to: to, size: "small", endIcon: _jsx(ChevronRightIcon, {}), sx: { textTransform: "none" }, children: "See All" }));
};
export var ManageButton = function (_a) {
    var to = _a.to, onClick = _a.onClick;
    return to ? (_jsx(IconButton, { component: RouterLink, to: to, size: "small", color: "primary", "aria-label": "Manage", title: "Manage", children: _jsx(EditIcon, { fontSize: "small" }) })) : (_jsx(IconButton, { onClick: onClick, size: "small", color: "primary", "aria-label": "Manage", title: "Manage", children: _jsx(EditIcon, { fontSize: "small" }) }));
};
